import React from "react";

function Type() {
  return (
    <h2 className="purple">
      QA Automation Engineer | Python Automation Engineer | Data Analyst
    </h2>
  );
}

export default Type;